import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CFormText
} from '@coreui/react-pro'
import AppTextColumnDetails from '../../../details/general-details/AppTextColumnDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import FormInvoiceRecipients from 'src/components/form/general-input-form/FormInvoiceRecipients'

// helpers
import { convertMoney } from '../../../../helpers/format-number'

const AppModalDetails = ({
  invoiceDetails,
  handleViewFile
}) => {
  let fileBupot = []
  let fileFaktur = []
  let fileShipping = []
  let shippingDetail = invoiceDetails?.shipping_detail ? invoiceDetails?.shipping_detail : null

  if (invoiceDetails?.bupot_url) {
    fileBupot = [{
      file_url: invoiceDetails?.bupot_url,
      file_original_name: invoiceDetails?.bupot_original_name
    }]
  }
  if (invoiceDetails?.faktur_url) {
    fileFaktur = [{
      file_url: invoiceDetails?.faktur_url,
      file_original_name: invoiceDetails?.faktur_original_name
    }]
  }
  if (shippingDetail?.file_url) {
    fileShipping = [{
      file_url: shippingDetail?.file_url,
      file_original_name: shippingDetail?.file_original_name
    }]
  }
  return (
    <>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="4"
          title="Name"
          subtitle={invoiceDetails?.name ? invoiceDetails?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Invoice value"
          subtitle={invoiceDetails?.value ? `IDR ${convertMoney(invoiceDetails?.value)}` : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Tax and other fees"
          subtitle={invoiceDetails?.tax_value ? `IDR ${convertMoney(invoiceDetails?.tax_value)}` : '-'}
        />
      </CRow>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="4"
          title="Description"
          subtitle={invoiceDetails?.description ? invoiceDetails?.description : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Due date"
          subtitle={invoiceDetails?.due_date ? moment(invoiceDetails?.due_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Tax due date"
          subtitle={invoiceDetails?.tax_due_date ? moment(invoiceDetails?.tax_due_date).format('DD/MM/YYYY') : '-'}
        />
      </CRow>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="4"
          title="Expected payment date"
          subtitle={invoiceDetails?.expected_payment_date ? moment(invoiceDetails?.expected_payment_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Project name"
          subtitle={invoiceDetails?.project ? invoiceDetails?.project?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Invoice number"
          subtitle={invoiceDetails?.invoice_number ? invoiceDetails?.invoice_number : '-'}
        />
      </CRow>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="4"
          title="Paid?"
          subtitle={invoiceDetails?.is_paid ? 'Yes' : 'No'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Invoice payment date"
          subtitle={invoiceDetails?.payment_date ? moment(invoiceDetails?.payment_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Draft?"
          subtitle={invoiceDetails?.is_draft ? 'Yes' : 'No'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Bukti potong PPh 23"
          subtitle={invoiceDetails?.bupot_required ? 'Yes' : 'No'}
        />
        <CCol>
          <CFormLabel>
            Document bukti potong PPh 23
          </CFormLabel>
          {
            fileBupot?.length > 0 ? (
              <FormFileThumbnail 
                colSize="12"
                files={fileBupot}
                isDetailPage={true}
                handleViewFile={handleViewFile}
              />
            ) : (
              <CCol>
                <CFormText>
                  No attachment
                </CFormText>
              </CCol>
            )
          }
        </CCol>
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Faktur pajak"
          subtitle={invoiceDetails?.faktur_required ? 'Yes' : 'No'}
        />
        <CCol>
          <CFormLabel>
            Document faktur pajak
          </CFormLabel>
          {
            fileFaktur?.length > 0 ? (
              <FormFileThumbnail 
                colSize="12"
                files={fileFaktur}
                isDetailPage={true}
                handleViewFile={handleViewFile}
              />
            ) : (
              <CCol>
                <CFormText>
                  No attachment
                </CFormText>
              </CCol>
            )
          }
        </CCol>
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          className={'mb-3'}
          title="Client name"
          subtitle={invoiceDetails?.client ? invoiceDetails?.client?.name : '-'}
        />
        {
          shippingDetail ? (
            <>
              {
                shippingDetail?.is_soft_copy && (
                  <>
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Recipient"
                      subtitle={shippingDetail?.recipient ? shippingDetail?.recipient : '-'}
                    />
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Email to"
                      subtitle={shippingDetail?.email_to ? shippingDetail?.email_to : '-'}
                    />
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Email date"
                      subtitle={shippingDetail?.email_date ? moment(shippingDetail?.email_date).format('DD/MM/YYYY') : '-'}
                    />
                  </>
                )
              }
              {
                shippingDetail?.is_hard_copy && (
                  <>
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Courier"
                      subtitle={shippingDetail?.courier ? shippingDetail?.courier?.toUpperCase() : '-'}
                    />
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Tracking number"
                      subtitle={shippingDetail?.tracking_no ? shippingDetail?.tracking_no : '-'}
                    />
                  </>
                )
              }
              {
                shippingDetail?.is_soft_copy || shippingDetail?.is_hard_copy ? (
                  <CCol lg={6}>
                    <CFormLabel>
                      Attachment
                    </CFormLabel>
                    {
                      fileShipping?.length > 0 ? (
                        <FormFileThumbnail 
                          colSize='12'
                          files={fileShipping}
                          isDetailPage={true}
                          handleViewFile={handleViewFile}
                        />
                      ) : (
                        <CCol>
                          <CFormText>
                            No attachment
                          </CFormText>
                        </CCol>
                      )
                    }
                  </CCol>
                ) : null
              }
            </>
          )
          : null
        }
      </CRow>
      <CRow className='mb-4'>
        <FormInvoiceRecipients 
          inputLabel={'Invoice Recipients'}
          recipients={invoiceDetails?.recipients}
          isDetail={true}
        />
      </CRow>
    </>
  )
}

export default AppModalDetails
